export default __webpack_public_path__ + "static/media/LP.a1e77e91.svg";